module.exports = __webpack_public_path__ + "img/banner1.9e91b9b5.png";